import { render, staticRenderFns } from "./ResumeInfoSnippetSection.vue?vue&type=template&id=833aae16&scoped=true&"
import script from "./ResumeInfoSnippetSection.vue?vue&type=script&lang=js&"
export * from "./ResumeInfoSnippetSection.vue?vue&type=script&lang=js&"
import style0 from "./ResumeInfoSnippetSection.vue?vue&type=style&index=0&id=833aae16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833aae16",
  null
  
)

export default component.exports